import cloneDeep from 'lodash/cloneDeep';

import { addMonths, getCalendarMonthWeeks } from '~/services/TimeService';

interface CalendarMonth {
  date: Date;
  weeks: ReturnType<typeof getCalendarMonthWeeks>;
}

const monthsArray = (firstDay: Date, numMonths: number, offset: number): Array<Date> => {
  const accum: Array<Date> = Array(numMonths);
  for (let i = 0; i < numMonths; i++) {
    const firstDayClone = cloneDeep(firstDay);
    accum[i] = addMonths(offset + i, firstDayClone);
  }
  return accum;
};

const getMonths = (firstDay: Date, numMonths: number, offset: number): Array<Date> => {
  return monthsArray(firstDay, numMonths, offset);
};

const getMonthWeeks = (month: Date): ReturnType<typeof getCalendarMonthWeeks> => {
  return getCalendarMonthWeeks(month, false);
};

const getCalendarGrid = (firstDay: Date, numMonths: number, offset: number): Array<CalendarMonth> => {
  return getMonths(firstDay, numMonths, offset).map((month) => {
    return {
      date: month,
      weeks: getMonthWeeks(month),
    };
  });
};

export default getCalendarGrid;
